require('../icons/sprite')

import Plyr from 'plyr'
import { Carousel, Fancybox } from '@fancyapps/ui'
import { Autoplay } from '@fancyapps/ui/dist/carousel.autoplay.esm.js'
Carousel.Plugins.Autoplay = Autoplay

import tippy from 'tippy.js'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

import { Draggable } from 'gsap/Draggable.js'
import { InertiaPlugin } from 'gsap/InertiaPlugin.js'

import MainNavigation from './modules/main-navigation'
import MobileNavigation from './modules/mobile-navigation'
import SideMenu from './modules/side-menu'
import CheckboxRadio from './modules/form-logics'
import DropdownFilter from './modules/dropdown-filter'
import FormAjaxSubmit from './modules/form-submit'
import FormWaitMessage from './modules/form-waitmessage'
import ActivityForm from './modules/activity-form'
// import ReadMore from './modules/read-more';
import FormBecomeProtector from './modules/form-beschermer'
import FormDonation from './modules/form-donatie'
import DonationMeter from './modules/donation-meter'
import FormNaturefund from './modules/form-natuurfonds'
import ShowMoreDates from './modules/show-more-dates'
import AdressAutofill from './modules/adressautofill'

gsap.registerPlugin(ScrollTrigger, Draggable, InertiaPlugin)

gsap.defaults({
  ease: 'power1.out',
  duration: 0.3,
})

class App {
  constructor() {
    this.onDocumentReady(this.init)
  }

  onDocumentReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      // call on next available tick
      setTimeout(fn, 1)
    } else {
      document.addEventListener('DOMContentLoaded', fn)
    }
  }

  init() {
    new CheckboxRadio()

    const menuItems = Array.from(document.querySelectorAll('.js-menu-item')).map((elem) => new MainNavigation(elem))
    const dropdownFilters = Array.from(document.querySelectorAll('.js-dropdown-filter')).map(
      (elem) => new DropdownFilter(elem)
    )
    const formElements = Array.from(document.querySelectorAll('.js-form')).map((elem) => new FormAjaxSubmit(elem))
    const formElementsWaitMessage = Array.from(document.querySelectorAll('.js-form-waitmessage')).map(
      (elem) => new FormWaitMessage(elem)
    )

    const players = Array.from(document.querySelectorAll('.js-player')).map((p) => new Plyr(p))

    players.forEach((element) => {
      if (!element.isEmbed) {
        /* If not youtube or vimeo */
        element.elements.container.classList.add('not-embedded-plyr-video')
      }
    })

    tippy('[data-tippy-content]', {
      trigger: 'mouseenter', // disable default on focus
      allowHTML: true,
      theme: 'light',
    })

    // BLN-676 Read more functionality disabled
    // Array.from(document.querySelectorAll('.js-read-more')).map((elem) => new ReadMore(elem));

    const formBecomeProtector = document.querySelector('.js-become-protector-form')
    if (formBecomeProtector) {
      new FormBecomeProtector(formBecomeProtector)
    }

    const formDonation = document.querySelector('.js-donation-form')
    if (formDonation) {
      new FormDonation(formDonation)
    }

    const formNaturefund = document.querySelector('.js-naturefunds-form')
    if (formNaturefund) {
      new FormNaturefund(formNaturefund)
    }

    const activityForm = document.getElementById('ActivitySubscribeForm')
    if (activityForm) {
      new ActivityForm(activityForm)
    }

    const donationmeter = document.querySelector('.js-donationmeter')
    if (donationmeter) {
      new DonationMeter(donationmeter)
    }

    const showMoreDates = document.querySelector('.js-showmoredates')
    if (showMoreDates) {
      new ShowMoreDates(showMoreDates)
    }

    new SideMenu()

    const mobileNavigation = document.querySelector('.js-side-menu')
    if (mobileNavigation) {
      new MobileNavigation(mobileNavigation)
    }
    // new MobileNavigation();

    new AdressAutofill()

    const headerHeight = 96
    const space = 24

    const sliderHolder = document.querySelector('.js-slider')
    if (sliderHolder) {
      const slider = sliderHolder.querySelector('.js-slider-element')
      const items = slider.querySelectorAll('.js-slider-item')
      const prev = sliderHolder.querySelector('.js-slider-prev')
      const next = sliderHolder.querySelector('.js-slider-next')
      const bullets = sliderHolder.querySelectorAll('.js-slider-bullet')

      let snap = [0]
      let currentIndex = 0

      items.forEach((element) => {
        snap.push(snap[snap.length - 1] - element.offsetWidth)
      })

      // remove last item
      snap = snap.slice(0, -1)

      Draggable.create(slider, {
        type: 'x',
        inertia: true,
        snap,
        onDragEnd: function () {
          beforeIndexChange()
          currentIndex = snap.indexOf(this.endX)
          afterIndexChange()
        },
      })

      prev.addEventListener('click', () => {
        beforeIndexChange()
        currentIndex--
        gsap.to(slider, { x: snap[currentIndex] })
        afterIndexChange()
      })

      next.addEventListener('click', () => {
        beforeIndexChange()
        currentIndex++
        gsap.to(slider, { x: snap[currentIndex] })
        afterIndexChange()
      })

      bullets.forEach((element) => {
        const trigger = element.querySelector('button')
        trigger.addEventListener('click', () => {
          beforeIndexChange()
          currentIndex = element.dataset.index
          gsap.to(slider, { x: snap[currentIndex] })
          afterIndexChange()
        })
      })

      function beforeIndexChange() {
        bullets[currentIndex].classList.remove('is--active')
      }

      function afterIndexChange() {
        bullets[currentIndex].classList.add('is--active')

        prev.disabled = currentIndex < 1 ? true : false
        next.disabled = currentIndex > items.length - 2 ? true : false
      }
    }

    const fadeInElements = document.querySelectorAll('.js-fade-in')
    fadeInElements.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: `top 70%`,
        },
        y: space * 2,
        opacity: 0,
        duration: 0.6,
      })
    })

    const animationYOffset = 32
    const animationScaleOffset = 0.9

    const carouselHero = Array.from(document.querySelectorAll('.js-carousel-hero')).map(
      (c) =>
        new Carousel(c, {
          Navigation: false,
          preload: 1,
          Autoplay: {
            timeout: 3000,
          },
          on: {
            ready: (carousel) => {
              for (let i = 0; i < carousel.slides.length; i++) {
                const element = carousel.slides[i].$el

                const title = element.querySelector('.js-hero-title')
                const subtitle = element.querySelector('.js-hero-subtitle')
                const textElements = element.querySelectorAll('.js-hero-text')
                const badges = element.querySelectorAll('.js-hero-badge')
                const badgeDivider = element.querySelectorAll('.js-hero-badge-divider')
                const labels = element.querySelectorAll('.js-hero-label')
                const buttons = element.querySelectorAll('.js-hero-button')

                if (title) {
                  gsap.set(title, {
                    y: animationYOffset,
                    opacity: 0,
                  })
                }
                if (subtitle) {
                  gsap.set(subtitle, {
                    y: animationYOffset,
                    opacity: 0,
                  })
                }
                if (textElements.length) {
                  gsap.set(textElements, { opacity: 0 })
                }
                if (badges.length) {
                  gsap.set(badges, {
                    scale: animationScaleOffset,
                    opacity: 0,
                  })
                }
                if (badgeDivider.length) {
                  gsap.set(badgeDivider, { opacity: 0 })
                }
                if (labels.length) {
                  gsap.set(labels, {
                    scale: animationScaleOffset,
                    opacity: 0,
                  })
                }
                if (buttons.length) {
                  gsap.set(buttons, {
                    scale: animationScaleOffset,
                    opacity: 0,
                  })
                }
              }
            },
            unselectSlide: (carousel) => {
              const prevPage = carousel.slides[carousel.prevPage].$el

              const title = prevPage.querySelector('.js-hero-title')
              const subtitle = prevPage.querySelector('.js-hero-subtitle')
              const textElements = prevPage.querySelectorAll('.js-hero-text')
              const badges = prevPage.querySelectorAll('.js-hero-badge')
              const badgeDivider = prevPage.querySelectorAll('.js-hero-badge-divider')
              const labels = prevPage.querySelectorAll('.js-hero-label')
              const buttons = prevPage.querySelectorAll('.js-hero-button')

              const tl = gsap.timeline()
              if (title) {
                tl.to(title, { y: animationYOffset, opacity: 0 }, '<25%')
              }
              if (subtitle) {
                tl.to(subtitle, { y: animationYOffset, opacity: 0 }, '<25%')
              }
              if (textElements.length) {
                tl.to(textElements, { opacity: 0 }, '<50%')
              }
              if (badges.length) {
                tl.to(badges, { scale: animationScaleOffset, opacity: 0 }, '<')
              }
              if (badgeDivider.length) {
                tl.to(badgeDivider, { opacity: 0 }, '<')
              }
              if (labels.length) {
                tl.to(labels, { scale: animationScaleOffset, opacity: 0 }, '<')
              }
              if (buttons.length) {
                tl.to(buttons, { scale: animationScaleOffset, opacity: 0 }, '<')
              }
            },
            selectSlide: (carousel) => {
              const page = carousel.slides[carousel.page].$el

              const title = page.querySelector('.js-hero-title')
              const subtitle = page.querySelector('.js-hero-subtitle')
              const textElements = page.querySelectorAll('.js-hero-text')
              const badges = page.querySelectorAll('.js-hero-badge')
              const badgeDivider = page.querySelectorAll('.js-hero-badge-divider')
              const labels = page.querySelectorAll('.js-hero-label')
              const buttons = page.querySelectorAll('.js-hero-button')

              const tl = gsap.timeline({ delay: 0.6 })

              if (title) {
                tl.to(title, { y: 0, opacity: 1 }, '<25%')
              }
              if (subtitle) {
                tl.to(subtitle, { y: 0, opacity: 1 }, '<25%')
              }
              if (textElements.length) {
                tl.to(textElements, { opacity: 1, stagger: 0.1 }, '<50%')
              }
              if (badges.length) {
                gsap.to(badges, { scale: 1, opacity: 1, stagger: 0.1 }, '<')
              }
              if (badgeDivider.length) {
                gsap.to(badgeDivider, { opacity: 1 }, '<')
              }
              if (labels.length) {
                gsap.to(labels, { scale: 1, opacity: 1, stagger: 0.1 }, '<')
              }
              if (buttons.length) {
                tl.to(buttons, { scale: 1, opacity: 1, stagger: 0.1 }, '<')
              }
            },
          },
        })
    )

    const carouselInline = Array.from(document.querySelectorAll('.js-carousel-inline')).map(
      (c) =>
        new Carousel(c, {
          Navigation: false,
          center: false,
          infinite: false,
          Autoplay: false,
          slidesPerPage: 'auto',
          fill: false,
        })
    )

    Fancybox.bind('.js-fancybox-content, [data-fancybox]', {
      closeButton: 'outside',
    })

    const filterOverview = document.querySelector('.js-filter-overview')
    if (filterOverview) {
      const apiLink = filterOverview.dataset.apilink
      const resetButton = filterOverview.querySelector('.js-resetfilters')
      const form = filterOverview.querySelector('form')
      const filterRegio = form.querySelector('input[name="Regio"]')
      const filterRegioCustomSelect = form.querySelector('.js-dropdown-filter-select')
      const filterRegioCustomSelectInitialText = form.querySelector('.js-dropdown-filter-select').innerHTML

      const filterCategorie = form.querySelector('select[name="Categories"]')
      const baseUrl = window.location.href.split('?')[0]

      let pagination = filterOverview.querySelector('.js-pagination') // update on fetch
      let region = false
      let category = false
      let paginationStart = false

      if (filterCategorie) {
        filterCategorie.addEventListener('change', () => {
          category = filterCategorie.value
          filterItems(true)
        })
      }

      if (filterRegio) {
        filterRegio.addEventListener('change', () => {
          region = filterRegio.value
          filterItems(true)
        })
      }

      if (pagination) {
        initPagination()
      }

      if (resetButton) {
        resetButton.addEventListener('click', () => {
          // Set inputs and values to 0:
          filterRegio.value = ''
          filterCategorie.value = ''
          region = ''
          category = ''

          // Reset inputs:
          filterCategorie.closest('.field.dropdown').classList.add('is--empty')

          filterRegioCustomSelect.value = ''
          filterRegioCustomSelect.innerHTML = filterRegioCustomSelectInitialText
          filterRegioCustomSelect.classList.add('is--empty')

          // Trigger filter action:
          filterItems(true)
        })
      }

      function toggleResetbutton() {
        if (filterRegio.value || filterCategorie.value) {
          resetButton.style.display = 'block'
        } else {
          resetButton.style.display = 'none'
        }
      }

      toggleResetbutton()

      function initPagination() {
        if (!pagination) return

        const paginationLinks = pagination.querySelectorAll('a.nav__link')

        paginationLinks.forEach((element) => {
          element.addEventListener('click', function (e) {
            e.preventDefault()

            const urlParams = new URLSearchParams(element.href.split('?')[1])
            paginationStart = urlParams.get('start')

            filterItems(false)
          })
        })
      }

      function filterItems(resetStart = false) {
        toggleResetbutton()
        const gridHolder = filterOverview.querySelector('.js-grid-holder')
        const skeletonHolder = filterOverview.querySelector('.js-projects-skeleton')

        const searchParams = new URLSearchParams()

        if (region) {
          searchParams.append('regio', region)
        }

        if (category) {
          searchParams.append('categorie', category)
        }

        if (paginationStart) {
          searchParams.append('start', paginationStart)
        }

        if (resetStart) {
          searchParams.delete('start')
        }

        window.history.pushState('', '', `${baseUrl}?${searchParams.toString()}`)

        searchParams.append('ajax', 1)

        // EMPTY div
        gridHolder.innerHTML = ''

        // Show Skeleton
        if (skeletonHolder) {
          skeletonHolder.style.display = 'block'
        }

        fetch(`${apiLink}?${searchParams.toString()}`, {
          headers: { 'x-requested-with': 'XMLHttpRequest' },
        })
          .then(function (response) {
            // The API call was successful!
            return response.text()
          })
          .then(function (html) {
            // Convert the HTML string into a document object
            const parser = new DOMParser()
            const doc = parser.parseFromString(html, 'text/html')

            // Hide Skeleton
            if (skeletonHolder) {
              skeletonHolder.style.display = 'none'
            }

            if (doc.body.firstChild) {
              gridHolder.append(doc.body.firstChild)
            } else {
              let p = document.createElement('p')
              p.innerHTML = 'Geen items gevonden.'
              gridHolder.append(p)
            }

            // scroll to top
            filterOverview.scrollIntoView({
              behavior: 'smooth',
            })

            // Reinit pagination
            pagination = gridHolder.querySelector('.js-pagination') ? gridHolder.querySelector('.js-pagination') : false
            initPagination()
          })
          .catch(function (err) {
            // There was an error
            console.warn('Something went wrong.', err)
          })
      }
    }
  }
}

window.app = new App()
